import {
    DateTimeType,
    PlainDateType,
    type PlainDateTimeType,
    type PlainTimeType,
} from '../types/dateTypes';
import '../enhanceDate';

export const DateHelper = {
    now(): DateTimeType {
        return Temporal.Now.instant().toString();
    },

    dateTimeToPlainDate(dateTime: DateTimeType): PlainDateType {
        return Temporal.Instant.from(dateTime)
            .toZonedDateTimeISO(config.TIME_ZONE)
            .toPlainDate()
            .toString();
    },

    dateTimeToPlainTime(dateTime: DateTimeType): PlainTimeType {
        return Temporal.Instant.from(dateTime)
            .toZonedDateTimeISO(config.TIME_ZONE)
            .toPlainTime()
            .toString();
    },

    plainDateToDateTime(plainDate: PlainDateType): DateTimeType {
        return Temporal.PlainDate.from(plainDate)
            .toZonedDateTime(config.TIME_ZONE)
            .toInstant()
            .toString();
    },

    plainDateTimeToDateTime(plainDateTime: PlainDateTimeType): DateTimeType {
        return Temporal.PlainDateTime.from(plainDateTime)
            .toZonedDateTime(config.TIME_ZONE)
            .toInstant()
            .toString();
    },

    dateRangeToPlainDateRange({
        min,
        max,
    }: {
        min: Date;
        max: Date;
    }): [PlainDateType, PlainDateType] {
        return [
            this.dateTimeToPlainDate(min.toTemporalInstant().toString()),
            this.dateTimeToPlainDate(max.toTemporalInstant().toString()),
        ];
    },

    plainDateRangeToDateRange([min, max]: [PlainDateType, PlainDateType]): {
        min: Date;
        max: Date;
    } {
        return {
            min: new Date(this.plainDateToDateTime(min)),
            max: new Date(this.plainDateToDateTime(max)),
        };
    },

    adjustTimeSpan(
        changed: 'start' | 'end',
        value: DateTimeType | null | undefined,
        [start, end]: [
            start: DateTimeType | null | undefined,
            end: DateTimeType | null | undefined,
        ],
    ): DateTimeType | null | undefined {
        const before = changed === 'start' ? start : end;
        const other = changed === 'start' ? end : start;

        if (!value || !other || (changed === 'start' ? value < other : value > other)) {
            return other;
        }

        let result;

        if (before) {
            const diff = Temporal.Instant.from(value).since(Temporal.Instant.from(before));
            result = Temporal.Instant.from(other).add(diff).toString();
        } else if (changed === 'start') {
            result = Temporal.Instant.from(value)
                .toZonedDateTimeISO(config.TIME_ZONE)
                .withPlainTime('20:00')
                .toInstant()
                .toString();
        } else {
            result = Temporal.Instant.from(value)
                .toZonedDateTimeISO(config.TIME_ZONE)
                .withPlainTime('08:00')
                .toInstant()
                .toString();
        }

        if (changed === 'start' ? value > result : value < result) {
            result = value;
        }

        return result;
    },
};
